import axiosV1 from "@/plugins/axios/configV1";

export default {
    /**
     * Fetch Archive
     */
    get(params) {
        return axiosV1.get(`users/archive`, { params });
    },
    getProfile(id, params) {
        return axiosV1.get(`users/archive/view/${id}`, { params });
    },
};
